import React from 'react'

const FooterSmartContractLogo = () => {
  return (
      <svg width="123" height="37" viewBox="0 0 123 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_191_248)">
                      <path
                          d="M8.49527 32.1309C11.1893 33.377 14.3425 34 17.9549 34V27.6632C14.4343 27.6632 11.725 26.9034 9.82696 25.3838C7.95953 23.8642 7.02582 21.676 7.02582 18.8191V18.2721C7.02582 15.4152 7.95953 13.2118 9.82696 11.6618C11.725 10.1118 14.4343 9.33676 17.9549 9.33676V3C14.3731 3 11.2199 3.63824 8.49527 4.91471C5.80127 6.16078 3.70424 7.93873 2.20418 10.2485C0.734726 12.5583 0 15.248 0 18.3176V18.7279C0 21.7976 0.734726 24.4873 2.20418 26.7971C3.70424 29.1069 5.80127 30.8848 8.49527 32.1309Z"
                          fill="url(#paint0_linear_191_248)"/>
                      <path
                          d="M61.5507 4.91471C58.8567 3.63824 55.7035 3 52.0911 3V9.33676C55.581 9.33676 58.2597 10.1118 60.1271 11.6618C62.0252 13.2118 62.9742 15.4152 62.9742 18.2721V18.8191C62.9742 21.676 62.0405 23.8642 60.173 25.3838C58.3362 26.9034 55.6422 27.6632 52.0911 27.6632V34C55.7035 34 58.8567 33.377 61.5507 32.1309C64.2446 30.8848 66.3264 29.1069 67.7958 26.7971C69.2653 24.4873 70 21.7976 70 18.7279V18.3176C70 15.248 69.2653 12.5583 67.7958 10.2485C66.3264 7.93873 64.2446 6.16078 61.5507 4.91471Z"
                          fill="url(#paint1_linear_191_248)"/>
                      <path d="M123 3V9.2378H103.187V15.3811H122.085V21.5716H103.187V27.7622H123V34H96.3227V3H123Z"
                            fill="#0F0F0F"/>
                      <path d="M89.169 3V34H82.5797L74 23.4855V13.4909L82.5797 23.9817V3H89.169Z" fill="#0F0F0F"/>
                      <path
                          d="M28.0104 16C28.7875 16 29.3769 16.2083 29.7786 16.625C30.1846 17.0417 30.3876 17.6489 30.3876 18.4466V18.561C30.3876 19.3587 30.1846 19.966 29.7786 20.3826C29.3769 20.7942 28.7875 21 28.0104 21H26V16H28.0104ZM28.0104 20.3216C29.1543 20.3216 29.7262 19.7373 29.7262 18.5686V18.439C29.7262 17.8598 29.5799 17.4228 29.2874 17.128C28.9993 16.8283 28.5714 16.6784 28.0039 16.6784H26.6549V20.3216H28.0104Z"
                          fill="#0F0F0F"/>
                      <path
                          d="M35.0645 16V16.6784H32.0652V18.157H34.9335V18.8354H32.0652V20.3216H35.0645V21H31.4103V16H35.0645Z"
                          fill="#0F0F0F"/>
                      <path
                          d="M40.4518 20.8857V21H39.7838L39.273 19.7348H36.85L36.3392 21H35.6712V20.8857L37.7013 16H38.4217L40.4518 20.8857ZM38.9914 19.0488L38.0615 16.7546L37.1316 19.0488H38.9914Z"
                          fill="#0F0F0F"/>
                      <path d="M41.837 16V20.3216H45V21H41.1821V16H41.837Z" fill="#0F0F0F"/>
              </g>
              <defs>
                      <linearGradient id="paint0_linear_191_248" x1="114.471" y1="80.595" x2="113.913" y2="13.7761"
                                      gradientUnits="userSpaceOnUse">
                              <stop stop-color="#4DD1B5"/>
                              <stop offset="0.33" stop-color="#3FBA9D"/>
                              <stop offset="0.43" stop-color="#3AAE94"/>
                              <stop offset="0.6" stop-color="#2F907E"/>
                              <stop offset="0.83" stop-color="#1D605B"/>
                              <stop offset="1" stop-color="#0E363D"/>
                      </linearGradient>
                      <linearGradient id="paint1_linear_191_248" x1="114.471" y1="80.595" x2="113.913" y2="13.7761"
                                      gradientUnits="userSpaceOnUse">
                              <stop stop-color="#4DD1B5"/>
                              <stop offset="0.33" stop-color="#3FBA9D"/>
                              <stop offset="0.43" stop-color="#3AAE94"/>
                              <stop offset="0.6" stop-color="#2F907E"/>
                              <stop offset="0.83" stop-color="#1D605B"/>
                              <stop offset="1" stop-color="#0E363D"/>
                      </linearGradient>
                      <clipPath id="clip0_191_248">
                              <rect width="123" height="37" fill="white"/>
                      </clipPath>
              </defs>
      </svg>
  )
}

export default FooterSmartContractLogo
